import React from 'react';
import { Field } from 'formik';
import { FormGroup, TextboxField, SelectDropdownField, Text } from '@tradingblock/components';
import styles from '../../../pages/HomePagePolish.module.css';
import { NAME_SUFFIX_OPTIONS } from '../../../types';

interface PersonalInfoStepProps {
  errors: any;
  touched: any;
  stepCompleted: boolean;
}

const PersonalInfoStep: React.FC<PersonalInfoStepProps> = React.memo(({ errors, touched, stepCompleted }) => (
  <>
    <div className="card h-100 mb-2" style={{ background: 'transparent' }}>
      <div className="card-body p-0">
        <div className="personal-info-section">
          <div className="field-group">
            <div className="stacked-fields">
              <FormGroup>
                <Field
                  component={TextboxField}
                  id="primaryAccountHolder.firstName"
                  defaultLabelId="firstName"
                  autoComplete="given-name"
                />
              </FormGroup>
              <FormGroup>
                <Field
                  component={TextboxField}
                  id="primaryAccountHolder.middleName"
                  defaultLabelId="middleName"
                  autoComplete="additional-name"
                />
              </FormGroup>
              <div className="name-suffix-row">
                <div className="lastname-col">
                  <FormGroup>
                    <Field
                      component={TextboxField}
                      id="primaryAccountHolder.lastName"
                      defaultLabelId="lastName"
                      autoComplete="family-name"
                    />
                  </FormGroup>
                </div>
                <div className="suffix-col">
                  <FormGroup>
                    <Field
                      component={SelectDropdownField}
                      id="primaryAccountHolder.suffix"
                      label={<span>Sfx</span>}
                      optionsDefaultLabelId="suffix"
                      options={NAME_SUFFIX_OPTIONS.map((option: any) => option.value)}
                      isSearchable={false}
                      isClearable={true}
                      menuPlacement="bottom"
                      menuPortalTargetId="portal-root"
                      onKeyDown={(e: React.KeyboardEvent) => {
                        if (e.key === 'Tab' && !e.shiftKey) {
                          e.preventDefault();
                          requestAnimationFrame(() => {
                            const emailInput = document.getElementById('primaryAccountHolder.email');
                            if (emailInput) {
                              (emailInput as HTMLInputElement).focus();
                            }
                          });
                        }
                      }}
                    />
                  </FormGroup>
                </div>
              </div>
              <FormGroup>
                <Field
                  component={TextboxField}
                  id="primaryAccountHolder.email"
                  type="email"
                  inputMode="email"
                  defaultLabelId="email"
                  autoComplete="email"
                  placeholder="Enter your email address"
                />
              </FormGroup>
              <FormGroup>
                <Field
                  component={TextboxField}
                  id="primaryAccountHolder.emailConfirm"
                  type="email"
                  inputMode="email"
                  defaultLabelId="emailConfirm"
                  autoComplete="email"
                  placeholder="Confirm your email address"
                />
              </FormGroup>
            </div>
          </div>
        </div>
      </div>
    </div>
    {stepCompleted && (
      <div className={styles.stepSuccess}>
        <i className="fas fa-check-circle" />
        <span>Personal information completed successfully!</span>
      </div>
    )}
  </>
));

export default PersonalInfoStep;
